module.exports = __webpack_public_path__ + "img/group_select_title.4a9dc91f.png";